import { type FC, type PropsWithChildren } from 'react';

import { clsx as cx } from 'clsx';

import * as styles from './styles.css';

interface IAdfoxCarouselBannerWrapperProps {
  fullWidth?: boolean;
}

export const AdfoxCarouselBannerWrapper: FC<PropsWithChildren<IAdfoxCarouselBannerWrapperProps>> = ({
  fullWidth,
  children,
}) => <li className={cx(styles['container'], fullWidth && styles['container--fullwidth'])}>{children}</li>;
